import provideDataHook from '~/helpers/provideDataHook';
import {
  CarFamily,
  getDataHook
} from '~/App/views/CarTreeAndCategory/CarFamily';

export default provideDataHook(
  'CarFamily',
  getDataHook({ mainCategory: 'car' })
)(CarFamily);
